import React from 'react';

import classes from './Button.module.css';

const triangle = (props) => (
    <div className={classes.TriangleDown}>
    </div>
);

export default triangle;